import * as charts from './charts'
import * as controls from './controls'
import * as generics from './generic'
import * as layout from './layout'
import * as visualization from './visualization'
import NebIcon from './Icon'

import './directives/clickOutside'

const Nebula = {
  install (Vue) {
    Object.keys(charts)
      .forEach(name => { Vue.component(name, charts[name]) })

    Object.keys(controls)
      .forEach(name => { Vue.component(name, controls[name]) })

    Object.keys(generics)
      .forEach(name => { Vue.component(name, generics[name]) })

    Object.keys(layout)
      .forEach(name => { Vue.component(name, layout[name]) })

    Object.keys(visualization)
      .forEach(name => { Vue.component(name, visualization[name]) })

    Vue.component('NebIcon', NebIcon)
  }
}

export default Nebula
